import React from "react";

// Data for SVG icons (some marked as dark)
const svgIcons = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
    { name: 'Vue.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg' },
    { name: 'Angular', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg' },
    { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
    { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
    { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
    { name: 'TypeScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
    { name: 'Express.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg', dark: true },
    { name: 'Django', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg', dark: true },
    { name: 'Flask', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg',  dark: true },
    { name: 'Ruby on Rails', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-original-wordmark.svg',  dark: true },
    { name: 'Spring Boot', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg' },
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
    { name: 'Flutter', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
    { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'},
    { name: 'Swift', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg' },
    { name: 'Kotlin', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg' },
    { name: 'Java', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg' },
    { name: 'Docker', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
    { name: 'Kubernetes', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg', dark: true },
    { name: 'NGINX', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg' },
    { name: 'Firebase', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg', dark: true },
];

const   HorizontalSvgScroller = () => {
    return (
        <section
            style={{
                overflow: "hidden",
                padding: 10,
                maskImage:
                    "linear-gradient(to right, rgba(0,0,0,0) 0%, black 10%, black 90%, rgba(0,0,0,0) 100%)",
                WebkitMaskImage:
                    "linear-gradient(to right, rgba(0,0,0,0) 0%, black 10%, black 90%, rgba(0,0,0,0) 100%)",
            }}
        >
            {/* Scroller Track */}
            <ul style={styles.sliderTrack}>
                {svgIcons.map((icon, index) => (
                    <li
                        key={index}
                        title={icon.name}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: 60,
                        }}
                    >
                        <img
                            src={icon.icon}
                            alt={icon.name}
                            style={{
                                height: 40,
                                width: 40,
                                objectFit: "contain",
                                backgroundColor: icon.dark ? "#fff" : "transparent",
                                padding: icon.dark ? 4 : 0,
                                borderRadius: 6,
                            }}
                        />
                    </li>
                ))}
            </ul>

            <style>{`
                @keyframes slideLeft {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }
            `}</style>
        </section>
    );
};

// CSS for scroller track
const styles = {
    sliderTrack: {
        display: "flex",
        gap: 48,
        width: "max-content",
        animation: "slideLeft 20s linear infinite",
    },
};

export default HorizontalSvgScroller;
